import {NameId} from '@drl/core/models';
import {Role} from '@drl/core/store/models/role.model';
import {Gender} from './gender.enum';
import {UserStatus} from '@drl/core/enums/user-status.enum';

export class User {
  id: number;
  patientName: string;
  firstName = '';
  middleName?: string;
  lastName?: string;
  username: string;
  email?: string;
  phone?: string;
  roleId: number;
  role: Role | any;
  permissions: string[];
  tenant: NameId;
  password?: string;
  lastLogin?: Date;
  status: any;
  externalId: string;
  gender: {id: Gender; name: string};
  designation: string;
  photo?: string;
  pubnubToken?: string;
  passwordExpiryTime?: Date;
  bio?: string;
  experience?: number;
  qualification?: string;
  lang?: string[];
  lastOtp?: string;
  lastOtpDate?: Date;
  lastOtpDateString?: string;
  isSelfOnb?: boolean;
  isAgeEntered?: boolean;
  isMinor?: boolean;
  caregiver:User;
  relation?:string
  location: string;
  relationLc: any;
  get fullName(): string {
    return [this.firstName, this.middleName, this.lastName]
    .filter(name => name) // Remove null/undefined/empty values
    .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()) // Capitalize each word
    .join(' ');
  }

  constructor(data?: Partial<User>) {
    if (data) {
      this.id = data.id;
      this.firstName = data.firstName;
      this.middleName = data.middleName;
      this.lastName = data.lastName;
      this.username = data.username;
      this.email = data.email;
      this.phone = data.phone;
      this.roleId = data.roleId;
      this.permissions = data.permissions;
      this.externalId = data.externalId;
      this.designation = data.designation;
      this.photo = data.photo;
      this.lang = data.lang;
      this.bio = data.bio;
      this.experience = data.experience;
      this.qualification = data.qualification;
      this.role=data.role;
      this.isSelfOnb = data.isSelfOnb;
    }
  }
}
